import { render } from "./AppBadge.vue?vue&type=template&id=646f153e&scoped=true&ts=true"
import script from "./AppBadge.vue?vue&type=script&lang=ts"
export * from "./AppBadge.vue?vue&type=script&lang=ts"

import "./AppBadge.vue?vue&type=style&index=0&id=646f153e&scoped=true&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646f153e"]])

export default __exports__